<template>
	<div class="home-page">
		<Head />
		<main class="main-content">
			<!-- Banner -->
			<section class="banner">
				<div class="container">
				</div>
				<!-- Banner 底部双卡片 -->
			</section>
			<div class="banner-cards-wrap">
				<div class="banner-cards-grid">
					<div class="banner-card">
						<div class="banner-card-icon banner-card-icon-platform">
							<img src="@/assets/ad_pro.png" alt="" />
						</div>
						<div>
							<h3 class="banner-card-title">S2B2C/O2O 品牌连锁加盟多应用系统</h3>
							<p class="banner-card-desc">为来访者提供心理评估·咨询·愈后跟进全链路解决方案
							</p>
						</div>
					</div>
					<div class="banner-card">
						<div class="banner-card-icon banner-card-icon-building">
							<img src="@/assets/ad_datong.png" alt="" />
						</div>
						<div>
							<h3 class="banner-card-title">B2C 私域化预约测评系统，</h3>
							<p class="banner-card-desc">私有化预约测评系统，便捷预约、精准测评，高效对接来访者需求</p>
						</div>
					</div>
				</div>
			</div>
			<!-- 产品与服务 -->
			<section id="products" class="section products-section">
				<div class="container">
					<h2 class="section-title">万象测评产品与服务</h2>
					<p class="section-desc">万象心理测评系统！以稳定的性能、卓越的品质赋能从业者！系统源码交付、支持独立部署、摆脱插件与 SaaS
						束缚，二开灵活高效。助力机构打造自主可控的心理测评平台。10000 + 机构的信赖之选！</p>
					<div class="product-grid">
						<div v-for="(item, index) in products" :key="item.title" class="product-card">
							<div class="product-card-header">
								<div class="product-icon" :class="'product-icon-' + (index + 1)">
									<i class="el-icon-s-shop"></i>
								</div>
								<div class="product-tag">{{ item.tag }}</div>
							</div>
							<h3 class="product-title">{{ item.title }}</h3>
							<p class="product-desc">{{ item.desc }}</p>
						</div>
					</div>
				</div>
			</section>
			<!-- 赋能开发者 -->
			<section id="solutions" class="section slogan-section">
				<div class="container">
					<h2 class="section-title">赋能心理行业，提高国民心理素质</h2>
					<p class="section-desc slogan-desc">赋能心理从业者，减少重复工作量！倾力打造稳定可靠、性能卓越、高准确率、高品质心理测评系统！</p>
					<div class="slogan-center-wrap">
						<svg class="slogan-lines" viewBox="0 0 600 500" preserveAspectRatio="xMidYMid meet">
							<line v-for="(_, i) in empowerFeatures" :key="'l'+i" class="slogan-line" :x1="300" :y1="250"
								:x2="lineEnds[i].x" :y2="lineEnds[i].y" />
						</svg>
						<div class="slogan-center">
							<div class="slogan-c-icon">
								<span class="slogan-c-letter">C</span>
							</div>
							<div class="slogan-platforms">
								<div class="slogan-platform slogan-platform-1"></div>
								<div class="slogan-platform slogan-platform-2"></div>
							</div>
						</div>
						<div v-for="(item, index) in empowerFeatures" :key="item.title" class="slogan-feature"
							:class="'slogan-feature-' + (index + 1)">
							<div class="slogan-feature-icon" :class="'slogan-feature-icon-' + (index + 1)"></div>
							<h3 class="slogan-feature-title">{{ item.title }}</h3>
							<p class="slogan-feature-desc">{{ item.line1 }}</p>
							<p class="slogan-feature-desc">{{ item.line2 }}</p>
						</div>
					</div>
				</div>
			</section>
			<!-- 电商领域全行业解决方案 -->
			<section class="section solutions-section">
				<div class="container">
					<h2 class="section-title solutions-title">心理测评领域全行业解决方案</h2>
					<p class="section-desc solutions-desc">
						从个体测评、团体测评、机构赋能到线上云测评、跨区域服务，构建全场景多维度线上线下智慧心理测评服务体系，为心理机构、企事业单位、中小学生、教育院校以及医院、部队，监狱等提供适用于团体定制、本地心理服务、跨区域测评等多种服务模式的应用场景数字化心理测评解决方案。
					</p>
					<div class="solutions-content">
						<div class="solutions-nav">
							<div v-for="(item, index) in solutions" :key="item.title" class="solutions-nav-item"
								:class="{ active: activeSolutionIndex === index }" @click="activeSolutionIndex = index">
								{{ item.title }}
							</div>
						</div>
						<div class="solutions-main">
							<div class="solutions-detail">
								<h3 class="solutions-detail-title">{{ currentSolution.title }}</h3>
								<p class="solutions-detail-desc">{{ currentSolution.desc }}</p>
								<div class="solutions-features">
									<div v-for="feature in currentSolution.features" :key="feature.name"
										class="solutions-feature">
										<div class="solutions-feature-icon" :class="'icon-' + feature.icon"></div>
										<span class="solutions-feature-name">{{ feature.name }}</span>
									</div>
								</div>
								<div class="solutions-buttons">
									<a v-for="btn in currentSolution.buttons" :key="btn.text" href="javascript:;"
										class="solutions-btn">
										{{ btn.text }}
									</a>
								</div>
							</div>
							<div class="solutions-illustration">
								<div class="solutions-3d-icon">
									<div class="cube"></div>
									<div class="tags">
										<div class="tag tag-1"></div>
										<div class="tag tag-2"></div>
										<div class="tag tag-3"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<!-- 多渠道全终端 极致用户体验 -->
			<section class="section omni-section">
				<div class="container omni-container">
					<h2 class="section-title omni-title">多渠道全终端 极致用户体验</h2>
					<p class="section-desc omni-desc">
						多渠道、多终端应用管理，数据统一、用户同步，为用户提供极致体验
					</p>
					<div class="omni-illustration">
						<img src="@/assets/duoduan.png" alt="多端设备展示" />
					</div>
				</div>
			</section>
			<!-- 实力优势 -->
			<section class="section advantages-section">
				<div class="container">
					<h2 class="section-title">实力强劲 为开发者保驾护航</h2>
					<p class="advantages-subtitle">
						用自由灵活、支持定制、高度拓展的系统产品，带给企业极致体验，满足客户消费需求
					</p>
					<!-- <div class="accordion">
						<div v-for="(item, index) in items" :key="index" class="accordion-item"
							@mouseenter="handleMouseEnter(index)" @mouseleave="handleMouseLeave">
							<div class="accordion-header">
								<span>{{ item.title }}</span>
							</div>
							<div v-show="activeIndex === index" class="accordion-content">
								<p>{{ item.content }}</p>
							</div>
						</div>
					</div> -->
					<div class="advantages-grid" @mouseleave="activeAdvantageIndex = 0">
						<div v-for="(item, index) in advantages" :key="item.title" class="advantage-card"
							:class="{ 'advantage-card-active': index === activeAdvantageIndex }"
							@mouseenter="activeAdvantageIndex = index">
							<div class="service_content">
								<img :src="index === activeAdvantageIndex ? codeIcon : item.icon">
								<p class="service_title">{{item.title}}</p>
								<p class="sm_line"></p>
								<p class="service_desc">{{item.desc}}</p>
							</div>
						</div>
					</div>
				</div>
			</section>

			<!-- 我们的合作客户 -->
			<section class="section clients-section">
				<div class="container">
					<h2 class="section-title">我们的合作客户</h2>
					<p class="section-desc clients-slogan">感知责任,优质回馈,合作共赢</p>
					<div class="clients-grid">
						<div v-for="(item, index) in clients" :key="index" class="client-card">
							<div class="client-logo">
								<img v-if="item.logo" :src="item.logo" :alt="item.name" />
								<span v-else class="client-name">{{ item.name }}</span>
							</div>
						</div>
					</div>
				</div>
			</section>

			<!-- Footer -->
			<SiteFooter />
		</main>
	</div>
</template>

<script>
	import Head from '@/components/head/index.vue';
	import SiteFooter from '@/components/footer/index.vue'
	import advantageIcon from '@/assets/feifanliuchang.png';
	import codeIcon from '@/assets/code_icon.png';
	import youxiaokongzhichenben from '@/assets/youxiaokongzhichenben.png';
	import zhichidingzhi from '@/assets/zhichidingzhi.png';
	import tiyan from '@/assets/tiyan.png';
	import zhinenggaoxiao from '@/assets/zhinenggaoxiao.png';
	import kuaisudajian from '@/assets/kuaisudajian.png';
	export default {
		name: 'Home',
		components: {
			Head,
			SiteFooter
		},
		data() {
			return {
				products: [{
						tag: '标准版PHP（B2C）',
						title: '标准化心理测评解决方案',
						desc: '系统基于lea+Uni-app开发，全开源无加密，方便二开，支持微信公众号、小程序、H5、PC、APP多端适配，助力企业快速搭建线上测评系统搭建。'
					},
					{
						tag: '预约咨询版PHP（可定制开发）',
						title: '标准化心理咨询机构解决方案',
						desc: '系统基于lea+Uni-app开发，包含测评、预约、课程、活动等模块，支持微信公众号、小程序、H5、PC、APP多端适配，助力心理咨询机构快速搭建线上测评系统。'
					},
					{
						tag: 'SAAS化多应用版（B2B2C）',
						title: '心理咨询机构多门店测评解决方案',
						desc: '系统基于lea+Uni-app开发，包含单人测评、通用团体测评等功能，快速开户，按次数付费，不同有应用可单独对接不同支持微信公众号、小程序、H5等。'
					},
					{
						tag: '中学生版（B2B2C）',
						title: '学校测评解决方案',
						desc: '万象中学生心理测评解决方案，100+测评量表，精准评估、科学分析，助力学校及机构守护青少年心理健康成长。'
					},
					{
						tag: '政企版（B2C）',
						title: '政企单位员工测评解决方案',
						desc: '万象政企单位员工测评解决方案，100+测评量表，科学筛查、精准研判，助力政企筑牢员工心理健康防线、提升团队凝聚力。'
					},
					{
						tag: '部队版JAVA（国有化操作系统）',
						title: '部队军人心理测评解决方案',
						desc: '万象部队军人心理测评解决方案，JAVA语言开发，国有化操作系统，科学筛查、精准评估，助力筑牢军人心理健康防线、凝聚强军力量。'
					},
					{
						tag: '监狱版JAVA（国有化操作系统）',
						title: '监狱版心理测评解决方案',
						desc: '万象监狱版心理测评解决方案，JAVA语言开发，国有化操作系统，科学筛查、精准研判，助力筑牢监管场所心理健康防线、维护安全稳定。'
					},
					{
						tag: '医院版JAVA ',
						title: '医院版心理测评解决方案',
						desc: '万象医院版心理测评解决方案，适配临床诊疗全流程，科学筛查、精准评估、规范存档，助力医院完善心理诊疗服务，守护就诊患者心理健康。'
					}
				],
				empowerFeatures: [{
						title: '二开方便',
						line1: '代码注释覆盖率≥90%',
						line2: '代码理解效率提升40%'
					},
					{
						title: '独立部署',
						line1: '100%私有化部署',
						line2: '15分钟完成安装搭建'
					},
					{
						title: '免费升级',
						line1: '每季度一次版本迭代',
						line2: '终生免费升级'
					},
					{
						title: '文档齐全',
						line1: '文档覆盖100%核心场景',
						line2: '新手踩坑率降低60%*'
					},
					{
						title: '高性可靠',
						line1: '日均10万+订单',
						line2: '承载稳定性达99.99%'
					}
				],
				lineEnds: [{
						x: 80,
						y: 90
					},
					{
						x: 520,
						y: 90
					},
					{
						x: 520,
						y: 250
					},
					{
						x: 420,
						y: 410
					},
					{
						x: 80,
						y: 410
					}
				],
				stats: [{
						value: '12年+',
						label: '技术沉淀与潜心积累'
					},
					{
						value: '40万+',
						label: '优秀开发者'
					},
					{
						value: '50万+',
						label: '企业客户'
					},
					{
						value: '900+',
						label: '技术服务商'
					}
				],
				advantages: [{
						icon: advantageIcon,
						title: '系统稳定安全',
						desc: '12年产品打磨沉淀,50w+开发者的选择;系统独立部署稳定可靠,数据自主掌控安全放心!'
					},
					{
						icon: youxiaokongzhichenben,
						title: '方便二次开发',
						desc: '代码开源、注释清晰、文档齐全、二开便捷，满足个性化定制需求'
					},
					{
						icon: zhichidingzhi,
						title: '支持免费升级',
						desc: '一次购买即享受终身免费升级权限，功能持续创新，价值日益增长'
					},
					{
						icon: tiyan,
						title: '系统文档齐全',
						desc: '具备全面的开发、接口、安装、使用文档，帮助用户快速安装使用'
					},
					{
						icon: zhinenggaoxiao,
						title: '源码高度开源',
						desc: '坚持系统代码高度开源，为开发者赋能，为创新开发奠定坚实基础'
					},
					{
						icon: kuaisudajian,
						title: '高并发高性能',
						desc: '系统并发能力强劲，坚持以用户为中心，提供高效率高质量的使用体验'
					}
				],
				activeAdvantageIndex: 0,
				codeIcon,
				clients: [
					{
						name: '以纯',
						logo: 'https://store.crmeb.net/uploads/attach/2022/08/20220831/8e1b58b0400fbef876a0ec724faae583.png'
					},
					{
						name: '红牛',
						logo: 'https://store.crmeb.net/uploads/attach/2022/08/20220831/f3c8571a3f435d0deadd751b6838bf47.png'
					},
					{
						name: '国王的朋友',
						logo: 'https://store.crmeb.net/uploads/attach/2022/08/20220831/acc4a32103eccedf6c1cd8357d3061c4.png'
					},
					
					{
						name: '老百姓大药房',
						logo: 'https://store.crmeb.net/uploads/attach/2022/08/20220831/86467fc9816f06b62cdbe6aed4cca54c.png'
					},
					
					{
						name: '金牛乳业',
						logo: 'https://store.crmeb.net/uploads/attach/2022/08/20220831/f29ddf13e7b6cacf82f2cf6d7881453d.png'
					},
					
					
					{
						name: '乾昌珠宝',
						logo: 'https://store.crmeb.net/uploads/attach/2022/08/20220831/c300e761d24fe2fdd131bcad16efd8ed.png'
					},
					{
						name: '鞍钢集团',
						logo: 'https://store.crmeb.net/uploads/attach/2022/08/20220831/35baa5146b68e9314faf9e7aa46be66e.png'
					},
					{
						name: '长城电缆',
						logo: 'https://store.crmeb.net/uploads/attach/2022/08/20220831/c839680036bfc4864e4e7e2df5503b1e.png'
					}
				],
				activeSolutionIndex: 0,
				solutions: [{
						title: '心理咨询工作室',
						desc: '以来访者为中心构建心理社群服务模式，重构工作室与来访者的关系，从咨询供需关系向社群化陪伴关系转变，社交赋能心理咨询服务竞争优势，结合工作室业务架构进行全渠道内容升级，实现咨询引流、私域运营等数字化管理经营。将来访者转化为工作室核心资产，提升咨询服务效率与口碑',
						features: [{
								icon: 'cart',
								name: '在线测评'
							},
							{
								icon: 'branch',
								name: '预约咨询'
							},
							{
								icon: 'group',
								name: '在线课程'
							},
							{
								icon: 'tag',
								name: '线下活动'
							},
							{
								icon: 'chart',
								name: '数据分析'
							},
							{
								icon: 'user',
								name: '会员管理'
							}
						]
					},
					{
						title: '心理测评独立版',
						desc: '100+测评量表，以测评使用者为中心构建测评社群服务模式，重构系统与测评使用者的关系，从测评供需关系向社群化服务关系转变，社交赋能心理测评管理系统竞争优势，结合系统服务架构进行全渠道内容升级，实现测评引流、私有化测评、管理团体测评，测评报告等数字化运营。将测评使用者转化为系统核心资产，提升测评管理效率与服务质感',
						features: [{
								icon: 'user',
								name: '量表管理'
							},
							{
								icon: 'tag',
								name: '测评管理'
							},
							{
								icon: 'chart',
								name: '团体测评'
							},
							{
								icon: 'cart',
								name: '测评报告'
							},
							{
								icon: 'branch',
								name: '预警处理'
							},
							{
								icon: 'group',
								name: '数据分析'
							}
						]
					},
					{
						title: '心理测评SaaS多应用版',
						desc: '整合S2B2C+O2O模式，为心理测评连锁机构、加盟门店提供线上线下一体化测评门店、测评服务、来访者管理解决方案，通过构建总部-门店协同管理中枢，进行测评项目/测评工具/合作供应商全域管控，跨店来访者权益通享+测评数据智能分析，驱动精准测评服务与引流，结合测评服务数字化+来访者精细化运营，助力心理测评连锁门店构建高效、精细化的全渠道运营体系',
						features: [{
								icon: 'cart',
								name: '应用管理'
							},
							{
								icon: 'tag',
								name: '会员管理'
							},
							{
								icon: 'user',
								name: '测评管理'
							},
							{
								icon: 'chart',
								name: '团体测评'
							},
							{
								icon: 'branch',
								name: '测评报告'
							},
							{
								icon: 'group',
								name: '数据分析'
							}
						]
					}
				],
				activeIndex: null,
				items: [{
						title: '标题 1',
						content: '这是第一个面板的内容。'
					},
					{
						title: '标题 2',
						content: '这是第二个面板的内容。'
					},
					{
						title: '标题 3',
						content: '这是第三个面板的内容。'
					}
				]

			};
		},
		computed: {
			currentSolution() {
				return this.solutions[this.activeSolutionIndex];
			}
		},
		methods: {
			// 鼠标移入某一项时展开
			handleMouseEnter(index) {
				this.activeIndex = index;
			},
			// 鼠标移出该项时收起
			handleMouseLeave() {
				this.activeIndex = null;
			}
		}
	};
</script>

<style scoped>
	.vx-img img {
		width: 100%;
	}

	.vx-img {
		width: 120px;
		height: 120px;
		display: flex;
		justify-content: center;
		margin: 0 auto;
		margin-bottom: 20px;
	}

	.service_content img {
		width: 62px;
		height: 62px;
		max-width: 100%;
		object-fit: contain;
	}

	.accordion-item {
		display: flex;
	}

	.home-page {
		min-height: 100vh;
		background: #f5f7fa;
	}

	.main-content {
		padding-top: 64px;
	}

	@media (max-width: 768px) {
		.main-content {
			padding-top: 56px;
		}
	}

	@media (max-width: 480px) {
		.main-content {
			padding-top: 48px;
		}
	}

	.container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 24px;
	}

	@media (max-width: 768px) {
		.container {
			padding: 0 16px;
		}
	}

	@media (max-width: 480px) {
		.container {
			padding: 0 12px;
		}
	}

	/* Banner */
	.banner {
		background-image: url(../../assets/7992420.jpg);
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		color: #fff;
		padding: 120px 0 0;
		text-align: center;
		min-height: 600px;
		display: flex;
		flex-direction: column;
		position: relative;
	}

	.banner-cards-wrap {
		margin-top: auto;
		padding: 24px 0 32px;
		width: 100%;
		position: absolute;
		z-index: 999;
		top: 565px;
	}

	.banner-title {
		font-size: 36px;
		font-weight: 700;
		margin: 0 0 12px;
		letter-spacing: 2px;
	}

	.banner-subtitle {
		font-size: 20px;
		opacity: 0.95;
		margin: 0 0 20px;
		letter-spacing: 4px;
	}

	.banner-desc {
		font-size: 16px;
		opacity: 0.9;
		max-width: 560px;
		margin: 0 auto 32px;
		line-height: 1.6;
	}

	@media (max-width: 768px) {
		.banner {
			padding: 60px 0 0;
			min-height: 450px;
			background-image: url(../../assets/banne.jpg);
			background-size: cover;
			background-position: center center;
		}

		.banner-title {
			font-size: 28px;
			letter-spacing: 1px;
		}

		.banner-subtitle {
			font-size: 16px;
			letter-spacing: 2px;
		}

		.banner-desc {
			font-size: 14px;
			padding: 0 16px;
		}

		.banner-cards-wrap {
			top: 420px;
			position: static;
			z-index: auto;
			/* margin-top: 24px; */
			/* 可按需要调整间距 */
		}

	}

	@media (max-width: 480px) {
		.banner {
			padding: 40px 0 0;
			min-height: 400px;
			background-size: contain;
			background-position: center center;
		}

		.banner-title {
			font-size: 24px;
			letter-spacing: 0.5px;
			padding: 0 12px;
		}

		.banner-subtitle {
			font-size: 14px;
			letter-spacing: 1px;
			padding: 0 12px;
		}

		.banner-desc {
			font-size: 13px;
			margin-bottom: 24px;
			padding: 0 12px;
		}

		.banner-cards-wrap {
			top: 360px;
			padding: 16px 0 24px;
		}

		.btn-primary,
		.btn-outline {
			padding: 10px 20px;
			font-size: 14px;
			width: calc(50% - 8px);
			min-width: 120px;
		}

		.banner-actions {
			padding: 0 12px;
		}
	}

	@media (max-width: 360px) {
		.banner-title {
			font-size: 22px;
		}

		.banner-subtitle {
			font-size: 13px;
		}

		.banner-desc {
			font-size: 12px;
		}

		.btn-primary,
		.btn-outline {
			font-size: 13px;
			padding: 9px 16px;
		}
	}

	.banner-actions {
		display: flex;
		justify-content: center;
		gap: 16px;
		flex-wrap: wrap;
	}

	.btn-primary {
		display: inline-block;
		padding: 12px 28px;
		background: #fff;
		color: #0369a1;
		border-radius: 6px;
		text-decoration: none;
		font-weight: 600;
		font-size: 15px;
	}

	.btn-primary:hover {
		background: #f0f9ff;
	}

	.btn-outline {
		display: inline-block;
		padding: 12px 28px;
		border: 2px solid rgba(255, 255, 255, 0.8);
		color: #fff;
		border-radius: 6px;
		text-decoration: none;
		font-weight: 600;
		font-size: 15px;
	}

	.btn-outline:hover {
		background: rgba(255, 255, 255, 0.15);
	}

	/* Banner 下双卡片 */
	.banner-cards-grid {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: 32px;
		max-width: 1000px;
		margin: 0 auto;
	}

	.banner-card {
		display: flex;
		align-items: center;
		padding: 32px 28px;
		background: #f8fafc;
		border: 1px solid #e2e8f0;
		border-radius: 12px;
		transition: box-shadow 0.2s, border-color 0.2s;
	}

	.banner-card:hover {
		box-shadow: 0 8px 24px rgba(24, 144, 255, 0.12);
		border-color: #1890ff;
	}

	.banner-card-icon {
		width: 56px;
		height: 56px;

		margin-right: 20px;
	}

	.banner-card-icon svg,
	.banner-card-icon img {
		width: 100%;
		height: 100%;
		max-width: 100%;
		object-fit: contain;
	}

	.banner-card-title {
		font-size: 18px;
		font-weight: 600;
		color: #1e293b;
		margin: 0 0 5px;
		line-height: 1.4;
	}

	.banner-card-desc {
		font-size: 14px;
		color: #64748b;
		line-height: 1.6;
		margin: 0;
	}

	@media (max-width: 768px) {
		.slogan-center {
			opacity: 0;
		}

		.banner-cards-grid {
			grid-template-columns: 1fr;
			gap: 20px;
			padding: 0 16px;
		}

		.banner-card {
			padding: 24px 20px;
		}

		.banner-card-icon {
			width: 48px;
			height: 48px;
			margin-right: 16px;
		}

		.banner-card-title {
			font-size: 16px;
		}

		.banner-card-desc {
			font-size: 13px;
		}
	}

	@media (max-width: 480px) {
		.banner-cards-grid {
			gap: 16px;
			padding: 0 12px;
		}

		.banner-card {
			padding: 20px 16px;
			flex-direction: column;
			text-align: center;
		}

		.banner-card-icon {
			margin-right: 0;
			margin-bottom: 12px;
		}

		.banner-card-title {
			font-size: 15px;
		}

		.banner-card-desc {
			font-size: 12px;
		}
	}

	/* Section 通用 */
	.section {
		padding: 64px 0;
	}

	.section-title {
		font-size: 40px;
		font-weight: 700;
		text-align: center;
		color: #1e293b;
		margin: 0 0 12px;
		margin-top: 30px;
	}

	.section-desc {
		text-align: center;
		font-size: 18px;
		font-family: PingFang SC;
		color: #666;
		max-width: 969px;
		margin: 0 auto 40px;
		line-height: 1.6;
	}

	@media (max-width: 1024px) {
		.section {
			padding: 48px 0;
		}

		.section-title {
			font-size: 32px;
		}

		.section-desc {
			font-size: 16px;
			margin-bottom: 32px;
		}
	}

	@media (max-width: 768px) {
		.section {
			padding: 10px 0;
		}

		.section-title {
			font-size: 28px;
			margin-top: 20px;
		}

		.section-desc {
			font-size: 15px;
			margin-bottom: 24px;
			padding: 0 16px;
		}
	}

	@media (max-width: 480px) {
		.section {
			padding: 32px 0;
		}

		.section-title {
			font-size: 24px;
			margin-top: 16px;
			padding: 0 12px;
		}

		.section-desc {
			font-size: 14px;
			margin-bottom: 20px;
			padding: 0 12px;
		}
	}

	@media (max-width: 360px) {
		.section-title {
			font-size: 22px;
		}

		.section-desc {
			font-size: 13px;
		}
	}

	/* 产品卡片 */
	.products-section {
		background: url(../../assets/section2_bg.png);
		position: relative;
		background-repeat: no-repeat;
		background-size: cover;
	}

	.product-grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 24px;
	}

	@media (max-width: 1024px) {
		.product-grid {
			grid-template-columns: repeat(2, 1fr);
			gap: 20px;
		}
	}

	@media (max-width: 768px) {
		.product-grid {
			gap: 16px;
		}

		.product-card {
			padding: 20px;
		}

		.product-title {
			font-size: 16px;
		}

		.product-desc {
			font-size: 13px;
		}
	}

	@media (max-width: 576px) {
		.product-grid {
			grid-template-columns: 1fr;
			gap: 16px;
		}

		.product-card {
			padding: 16px;
		}

		.product-title {
			font-size: 15px;
		}

		.product-desc {
			font-size: 12px;
		}
	}

	.product-card {
		background: #fff;
		border: 1px solid #e2e8f0;
		border-radius: 8px;
		padding: 24px;
		transition: box-shadow 0.2s, border-color 0.2s;
	}

	.product-card-header {
		display: flex;
		align-items: center;
		margin-bottom: 12px;
	}

	.product-icon {
		width: 40px;
		height: 40px;
		border-radius: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		font-size: 22px;
		margin-right: 10px;
	}

	/* 每个产品卡片图标不同背景色（共 8 个） */
	.product-icon-1 {
		background: linear-gradient(135deg, #f97316 0%, #facc15 100%);
	}

	.product-icon-2 {
		background: linear-gradient(135deg, #3b82f6 0%, #38bdf8 100%);
	}

	.product-icon-3 {
		background: linear-gradient(135deg, #10b981 0%, #6ee7b7 100%);
	}

	.product-icon-4 {
		background: linear-gradient(135deg, #8b5cf6 0%, #a855f7 100%);
	}

	.product-icon-5 {
		background: linear-gradient(135deg, #ec4899 0%, #f97316 100%);
	}

	.product-icon-6 {
		background: linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%);
	}

	.product-icon-7 {
		background: linear-gradient(135deg, #f59e0b 0%, #ef4444 100%);
	}

	.product-icon-8 {
		background: linear-gradient(135deg, #6366f1 0%, #06b6d4 100%);
	}

	.product-icon .el-icon-s-shop {
		font-size: 22px;
	}

	.product-card:hover {
		box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
		border-color: #1890ff;
	}

	.product-tag {
		display: inline-block;
		font-size: 12px;
		color: #1890ff;
		background: #e6f4ff;
		padding: 4px 10px;
		border-radius: 4px;
		margin-bottom: 0;
	}

	.product-title {
		font-size: 18px;
		font-weight: 600;
		color: #1e293b;
		margin: 0 0 12px;
	}

	.product-desc {
		font-size: 14px;
		color: #64748b;
		line-height: 1.6;
		margin: 0 0 16px;
	}

	.product-link {
		color: #1890ff;
		text-decoration: none;
		font-size: 14px;
	}

	.product-link:hover {
		text-decoration: underline;
	}

	/* 赋能开发者 */
	.slogan-section {
		background: #f8fafc;
		position: relative;
		overflow: hidden;
	}

	.slogan-section::before {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		background-image: radial-gradient(circle at 20% 30%, rgba(14, 165, 233, 0.06) 0%, transparent 50%),
			radial-gradient(circle at 80% 70%, rgba(14, 165, 233, 0.05) 0%, transparent 50%);
		pointer-events: none;
	}

	.slogan-desc {
		font-size: 18px;
	}

	.slogan-center-wrap {
		position: relative;
		width: 100%;
		max-width: 900px;
		height: 720px;
		margin: 0 auto;
	}

	.slogan-lines {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		width: 100%;
		height: 100%;
		pointer-events: none;
	}

	.slogan-line {
		stroke: #0ea5e9;
		stroke-width: 1;
		stroke-dasharray: 6 6;
		stroke-opacity: 0.4;
	}

	.slogan-center {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		display: flex;
		flex-direction: column;
		align-items: center;
		z-index: 2;
	}

	.slogan-c-icon {
		width: 100px;
		height: 100px;
		background: linear-gradient(145deg, #38bdf8 0%, #0ea5e9 40%, #0284c7 100%);
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0 8px 24px rgba(14, 165, 233, 0.35);
	}

	.slogan-c-letter {
		font-size: 48px;
		font-weight: 800;
		color: #fff;
		font-family: 'Avenir', Helvetica, sans-serif;
		line-height: 1;
	}

	.slogan-platforms {
		position: relative;
		margin-top: -8px;
	}

	.slogan-platform {
		height: 12px;
		border-radius: 4px;
		background: linear-gradient(90deg, #7dd3fc 0%, #0ea5e9 50%, #0369a1 100%);
	}

	.slogan-platform-1 {
		width: 80px;
		margin: 0 auto 4px;
	}

	.slogan-platform-2 {
		width: 100px;
		margin: 0 auto;
	}

	.slogan-feature {
		position: absolute;
		width: 160px;
		text-align: center;
		z-index: 2;
	}

	.slogan-feature-1 {
		left: 0;
		top: 8%;
	}

	.slogan-feature-2 {
		right: 0;
		top: 8%;
	}

	.slogan-feature-3 {
		right: 4%;
		top: 50%;
		transform: translateY(-50%);
	}

	.slogan-feature-4 {
		right: 8%;
		bottom: 12%;
	}

	.slogan-feature-5 {
		left: 0;
		bottom: 12%;
	}

	.slogan-feature-icon {
		width: 48px;
		height: 48px;
		margin: 0 auto 10px;
		border-radius: 50%;
		background: linear-gradient(145deg, #0ea5e9 0%, #0284c7 100%);
		position: relative;
	}

	.slogan-feature-icon-1::after {
		content: '';
		position: absolute;
		left: 50%;
		top: 50%;
		width: 20px;
		height: 24px;
		background: #fff;
		border-radius: 2px;
		transform: translate(-50%, -50%);
		margin-left: 2px;
	}

	.slogan-feature-icon-2::after {
		content: '';
		position: absolute;
		left: 50%;
		top: 50%;
		width: 18px;
		height: 18px;
		border: 2px solid #fff;
		border-radius: 2px;
		transform: translate(-50%, -50%);
		box-shadow: 0 2px 0 #fff;
	}

	.slogan-feature-icon-3::after {
		content: '';
		position: absolute;
		left: 50%;
		top: 50%;
		width: 16px;
		height: 16px;
		border: 2px solid #fff;
		border-radius: 50%;
		border-top-color: transparent;
		transform: translate(-50%, -50%);
		animation: slogan-spin 3s linear infinite;
	}

	@keyframes slogan-spin {
		to {
			transform: translate(-50%, -50%) rotate(360deg);
		}
	}

	.slogan-feature-icon-4::after {
		content: '';
		position: absolute;
		left: 50%;
		top: 50%;
		width: 18px;
		height: 22px;
		background: repeating-linear-gradient(#fff 0, #fff 3px, transparent 3px, transparent 7px);
		background-size: 100% 7px;
		border-radius: 1px;
		transform: translate(-50%, -50%);
	}

	.slogan-feature-icon-5::after {
		content: '';
		position: absolute;
		left: 50%;
		top: 50%;
		width: 18px;
		height: 20px;
		background: #fff;
		clip-path: polygon(30% 0%, 70% 0%, 70% 40%, 100% 40%, 50% 100%, 0% 40%, 30% 40%);
		transform: translate(-50%, -50%);
	}

	.slogan-feature-title {
		font-size: 22px;
		font-weight: 600;
		color: #1e293b;
		margin: 0 0 8px;
	}

	.slogan-feature-desc {
		font-size: 16px;
		color: #64748b;
		line-height: 1.5;
		margin: 0 0 2px;
	}

	@media (max-width: 1024px) {
		.slogan-center-wrap {
			height: auto;
			min-height: 600px;
			padding-bottom: 24px;
		}

		.slogan-c-icon {
			width: 80px;
			height: 80px;
		}

		.slogan-c-letter {
			font-size: 40px;
		}

		.slogan-feature-title {
			font-size: 20px;
		}

		.slogan-feature-desc {
			font-size: 15px;
		}
	}

	@media (max-width: 768px) {
		.slogan-center-wrap {
			height: auto;
			min-height: 0;
			padding-bottom: 0;
			display: flex;
			flex-direction: column;
			gap: 14px;
		}

		.slogan-lines {
			display: none;
		}

		.slogan-center {
			display: none;
		}

		.slogan-feature {
			position: static;
			width: 100%;
			max-width: 100%;
			margin: 0;
			background: #fff;
			border-radius: 12px;
			padding: 16px 14px;
			box-sizing: border-box;
			box-shadow: 0 2px 10px rgba(15, 23, 42, 0.06);
		}

		.slogan-feature-3 {
			transform: none;
		}

		.slogan-feature-icon {
			width: 42px;
			height: 42px;
			margin-bottom: 10px;
		}

		.slogan-feature-title {
			font-size: 17px;
			margin-bottom: 6px;
		}

		.slogan-feature-desc {
			font-size: 14px;
			line-height: 1.6;
		}
	}

	@media (max-width: 480px) {
		.slogan-center-wrap {
			gap: 12px;
		}

		.slogan-feature-icon {
			width: 40px;
			height: 40px;
		}

		.slogan-feature-title {
			font-size: 16px;
		}

		.slogan-feature-desc {
			font-size: 13px;
		}
	}

	/* 电商领域全行业解决方案 */
	.solutions-section {
		background: url(../../assets/shangjairuzhu.jpg);
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		color: #fff;
		padding: 80px 0;
		position: relative;
		overflow: hidden;
	}

	.solutions-section::before {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.4);
		pointer-events: none;
	}

	.solutions-title {
		color: #fff;
		font-size: 40px;
		margin-bottom: 16px;
	}

	.solutions-desc {
		color: rgba(255, 255, 255, 0.85);
		font-size: 18px;
		max-width: 900px;
		margin-bottom: 48px;
	}

	.solutions-content {
		display: flex;
		gap: 40px;
		position: relative;
		z-index: 1;
		max-width: 1200px;
		width: 100%;
		margin: 0 auto;
		background: black;
		opacity: 0.8;
		border-radius: 8px;
		padding: 0;
	}

	.solutions-nav {
		flex-shrink: 0;
		width: 200px;
		padding: 56px 0 0;
	}

	.solutions-nav-item {
		padding: 16px 20px;
		cursor: pointer;
		color: rgba(255, 255, 255, 0.7);
		border-radius: 6px;
		margin-bottom: 8px;
		transition: all 0.3s;
		font-size: 15px;
	}

	.solutions-nav-item:hover {
		background: rgba(255, 255, 255, 0.05);
		color: rgba(255, 255, 255, 0.9);
	}

	.solutions-nav-item.active {
		background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
		color: #fff;
		font-weight: 600;
	}

	.solutions-main {
		flex: 1;
		display: flex;
		gap: 40px;
		align-items: flex-start;
		padding: 56px 40px 0;
		height: 540px;
	}

	.solutions-detail {
		flex: 1;
	}

	.solutions-detail-title {
		font-size: 28px;
		font-weight: 700;
		color: #fff;
		margin: 0 0 20px;
	}

	.solutions-detail-desc {
		font-size: 15px;
		color: rgba(255, 255, 255, 0.8);
		line-height: 1.8;
		margin: 0 0 32px;
	}

	.solutions-features {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 24px;
		margin-bottom: 32px;
	}

	.solutions-feature {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 8px;
	}

	.solutions-feature-icon {
		width: 48px;
		height: 48px;
		border-radius: 8px;
		background: rgba(14, 165, 233, 0.15);
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
	}

	.solutions-feature-icon.icon-cart::after {
		content: '';
		width: 24px;
		height: 20px;
		border: 2px solid #0ea5e9;
		border-radius: 3px 3px 0 0;
		position: relative;
		top: -2px;
	}

	.solutions-feature-icon.icon-cart::before {
		content: '';
		position: absolute;
		width: 8px;
		height: 8px;
		border: 2px solid #0ea5e9;
		border-radius: 50%;
		top: 8px;
		right: -4px;
	}

	.solutions-feature-icon.icon-branch::after {
		content: '';
		width: 20px;
		height: 20px;
		border: 2px solid #0ea5e9;
		border-radius: 50%;
		position: relative;
	}

	.solutions-feature-icon.icon-branch::before {
		content: '';
		position: absolute;
		width: 2px;
		height: 12px;
		background: #0ea5e9;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		box-shadow: -6px 0 0 #0ea5e9, 6px 0 0 #0ea5e9;
	}

	.solutions-feature-icon.icon-group::after {
		content: '';
		width: 20px;
		height: 20px;
		border: 2px solid #0ea5e9;
		border-radius: 50%;
		position: relative;
	}

	.solutions-feature-icon.icon-group::before {
		content: '';
		position: absolute;
		width: 16px;
		height: 16px;
		border: 2px solid #0ea5e9;
		border-radius: 50%;
		top: 4px;
		left: 4px;
	}

	.solutions-feature-icon.icon-tag::after {
		content: '';
		width: 20px;
		height: 16px;
		background: #0ea5e9;
		clip-path: polygon(0 0, 100% 0, 85% 100%, 0 100%);
		position: relative;
	}

	.solutions-feature-icon.icon-chart {
		background: rgba(14, 165, 233, 0.15);
	}

	.solutions-feature-icon.icon-chart::after {
		content: '';
		width: 20px;
		height: 14px;
		border-bottom: 2px solid #0ea5e9;
		border-left: 2px solid #0ea5e9;
		position: relative;
		top: 2px;
		clip-path: polygon(0 100%, 100% 0, 100% 100%, 0 100%);
	}

	.solutions-feature-icon.icon-chart::before {
		content: '';
		position: absolute;
		width: 3px;
		height: 3px;
		background: #0ea5e9;
		border-radius: 50%;
		bottom: 8px;
		left: 2px;
		box-shadow: 5px -4px 0 #0ea5e9, 10px -2px 0 #0ea5e9, 15px -6px 0 #0ea5e9;
	}

	.solutions-feature-icon.icon-user::after {
		content: '';
		width: 16px;
		height: 16px;
		border: 2px solid #0ea5e9;
		border-radius: 50%;
		position: relative;
		top: -2px;
	}

	.solutions-feature-icon.icon-user::before {
		content: '';
		position: absolute;
		width: 20px;
		height: 10px;
		border: 2px solid #0ea5e9;
		border-top: none;
		border-radius: 0 0 10px 10px;
		bottom: -4px;
		left: 50%;
		transform: translateX(-50%);
	}

	.solutions-feature-name {
		font-size: 13px;
		color: rgba(255, 255, 255, 0.8);
		text-align: center;
	}

	.solutions-buttons {
		display: flex;
		gap: 16px;
		flex-wrap: wrap;
		margin-top: 50px;
		border-top: 1px solid rgba(255, 255, 255, 0.5);
		padding-top: 50px;

	}

	.solutions-btn {
		display: inline-block;
		padding: 10px 24px;
		background: rgba(255, 255, 255, 0.1);
		border: 1px solid rgba(255, 255, 255, 0.2);
		border-radius: 6px;
		color: #fff;
		text-decoration: none;
		font-size: 14px;
		transition: all 0.3s;
	}

	.solutions-btn:hover {
		background: rgba(14, 165, 233, 0.2);
		border-color: #0ea5e9;
		color: #fff;
	}

	.solutions-illustration {
		flex-shrink: 0;
		width: 200px;
		height: 200px;
		position: relative;
	}

	.solutions-3d-icon {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.solutions-3d-icon .cube {
		width: 80px;
		height: 80px;
		position: absolute;
		left: 50%;
		top: 20%;
		transform: translateX(-50%) rotateX(45deg) rotateY(45deg);
		background: linear-gradient(135deg, rgba(14, 165, 233, 0.3) 0%, rgba(2, 132, 199, 0.5) 100%);
		border: 2px solid rgba(14, 165, 233, 0.6);
		box-shadow: 0 0 30px rgba(14, 165, 233, 0.4);
		animation: solutions-glow 3s ease-in-out infinite;
	}

	@keyframes solutions-glow {

		0%,
		100% {
			box-shadow: 0 0 30px rgba(14, 165, 233, 0.4);
		}

		50% {
			box-shadow: 0 0 50px rgba(14, 165, 233, 0.6);
		}
	}

	.solutions-3d-icon .tags {
		position: absolute;
		width: 100%;
		height: 100%;
	}

	.solutions-3d-icon .tag {
		position: absolute;
		width: 40px;
		height: 30px;
		background: rgba(14, 165, 233, 0.2);
		border: 1px solid rgba(14, 165, 233, 0.4);
		border-radius: 4px;
		animation: solutions-float 4s ease-in-out infinite;
	}

	.solutions-3d-icon .tag-1 {
		top: 10%;
		right: 10%;
		animation-delay: 0s;
	}

	.solutions-3d-icon .tag-2 {
		top: 50%;
		right: 5%;
		animation-delay: 1.3s;
	}

	.solutions-3d-icon .tag-3 {
		bottom: 15%;
		right: 15%;
		animation-delay: 2.6s;
	}

	@keyframes solutions-float {

		0%,
		100% {
			transform: translateY(0) rotate(0deg);
		}

		50% {
			transform: translateY(-10px) rotate(5deg);
		}
	}

	@media (max-width: 1024px) {
		.solutions-section {
			padding: 60px 0;
		}

		.solutions-title {
			font-size: 32px;
		}

		.solutions-desc {
			font-size: 16px;
			padding: 0 16px;
		}

		.solutions-content {
			flex-direction: column;
			gap: 0;
		}

		.solutions-nav {
			width: 100%;
			display: flex;
			overflow-x: auto;
			gap: 8px;
			padding: 20px 16px 0;
		}

		.solutions-nav-item {
			white-space: nowrap;
			margin-bottom: 0;
			font-size: 14px;
			padding: 12px 16px;
		}

		.solutions-main {
			flex-direction: column;
			height: auto;
			padding: 32px 24px;
		}

		.solutions-detail-title {
			font-size: 24px;
		}

		.solutions-detail-desc {
			font-size: 14px;
		}

		.solutions-features {
			grid-template-columns: repeat(3, 1fr);
			gap: 16px;
		}

		.solutions-buttons {
			margin-top: 32px;
			padding-top: 32px;
		}

		.solutions-illustration {
			width: 100%;
			height: 150px;
			margin-top: 24px;
		}
	}

	@media (max-width: 768px) {
		.solutions-section {
			padding: 48px 0;
		}

		.solutions-title {
			font-size: 28px;
		}

		.solutions-desc {
			font-size: 15px;
		}

		.solutions-nav {
			padding: 16px 12px 0;
		}

		.solutions-nav-item {
			font-size: 13px;
			padding: 10px 14px;
		}

		.solutions-main {
			padding: 24px 16px;
		}

		.solutions-detail-title {
			font-size: 22px;
			margin-bottom: 16px;
		}

		.solutions-detail-desc {
			font-size: 13px;
			margin-bottom: 24px;
		}

		.solutions-features {
			grid-template-columns: repeat(2, 1fr);
			gap: 16px;
			margin-bottom: 24px;
		}

		.solutions-feature-icon {
			width: 40px;
			height: 40px;
		}

		.solutions-feature-name {
			font-size: 12px;
		}

		.solutions-buttons {
			margin-top: 24px;
			padding-top: 24px;
			gap: 12px;
		}

		.solutions-btn {
			padding: 8px 20px;
			font-size: 13px;
		}

		.solutions-illustration {
			height: 120px;
			display: none;
		}
	}

	@media (max-width: 480px) {
		.solutions-section {
			padding: 40px 0;
		}

		.solutions-title {
			font-size: 24px;
			padding: 0 12px;
		}

		.solutions-desc {
			font-size: 14px;
			padding: 0 12px;
		}

		.solutions-nav {
			padding: 12px 8px 0;
			gap: 6px;
		}

		.solutions-nav-item {
			font-size: 12px;
			padding: 8px 12px;
		}

		.solutions-main {
			padding: 20px 12px;
		}

		.solutions-detail-title {
			font-size: 20px;
		}

		.solutions-detail-desc {
			font-size: 12px;
		}

		.solutions-features {
			grid-template-columns: repeat(2, 1fr);
			gap: 12px;
		}

		.solutions-feature-icon {
			width: 36px;
			height: 36px;
		}

		.solutions-feature-name {
			font-size: 11px;
		}

		.solutions-buttons {
			flex-direction: column;
			gap: 10px;
		}

		.solutions-btn {
			width: 100%;
			text-align: center;
		}

		.solutions-illustration {
			height: 100px;
		}
	}

	@media (max-width: 360px) {
		.solutions-title {
			font-size: 22px;
		}

		.solutions-desc {
			font-size: 13px;
		}

		.solutions-nav-item {
			font-size: 11px;
			padding: 7px 10px;
		}

		.solutions-detail-title {
			font-size: 18px;
		}

		.solutions-detail-desc {
			font-size: 11px;
		}

		.solutions-feature-name {
			font-size: 10px;
		}
	}

	/* 多渠道全终端 极致用户体验 */
	.omni-section {
		background: #f4f6fb;
		padding: 80px 0;
	}

	.omni-container {
		text-align: center;
	}

	.omni-title {
		margin-top: 0;
		margin-bottom: 12px;
	}

	.omni-desc {
		margin-bottom: 40px;
		color: #6b7280;
	}

	.omni-illustration {
		position: relative;
		max-width: 1000px;
		margin: 0 auto;
	}

	.omni-illustration img {
		width: 100%;
		display: block;
	}

	.omni-tag {
		position: absolute;
		padding: 6px 16px;
		background: #ffffff;
		border-radius: 999px;
		font-size: 12px;
		color: #4b5563;
		box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
		white-space: nowrap;
	}

	.omni-tag-device {
		left: 8%;
		bottom: 18%;
	}

	.omni-tag-app {
		left: 32%;
		bottom: 10%;
	}

	.omni-tag-backend {
		right: 24%;
		bottom: 26%;
	}

	.omni-tag-pc {
		left: 50%;
		top: 6%;
		transform: translateX(-50%);
	}

	.omni-tag-cashier {
		right: 10%;
		top: 22%;
	}

	.omni-tag-mini {
		right: 10%;
		bottom: 8%;
	}

	@media (max-width: 1024px) {
		.omni-section {
			padding: 60px 0;
		}

		.omni-desc {
			font-size: 16px;
			padding: 0 16px;
		}
	}

	@media (max-width: 768px) {
		.omni-section {
			padding: 48px 0;
		}

		.omni-desc {
			font-size: 14px;
			margin-bottom: 32px;
			padding: 0 12px;
		}

		.omni-tag {
			font-size: 11px;
			padding: 4px 10px;
		}
	}

	@media (max-width: 576px) {
		.omni-section {
			padding: 40px 0;
		}

		.omni-illustration {
			max-width: 100%;
		}

		/* 小屏下标签靠下排列，避免遮挡核心图片 */
		.omni-tag-device,
		.omni-tag-app,
		.omni-tag-backend,
		.omni-tag-pc,
		.omni-tag-cashier,
		.omni-tag-mini {
			position: static;
			display: inline-block;
			margin: 8px 6px 0;
			box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
		}

		.omni-illustration {
			padding-bottom: 8px;
		}
	}

	/* 数据统计 */
	.stats-section {
		background: linear-gradient(135deg, #0c4a8a 0%, #0369a1 100%);
		color: #fff;
		padding: 48px 0;
	}

	.stats-grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 24px;
		text-align: center;
	}

	@media (max-width: 768px) {
		.stats-grid {
			grid-template-columns: repeat(2, 1fr);
		}
	}

	.stat-value {
		font-size: 32px;
		font-weight: 700;
		margin-bottom: 8px;
	}

	.stat-label {
		font-size: 14px;
		opacity: 0.9;
	}

	/* 实力优势 */
	.advantages-section {
		background: url(../../assets/index_section6_bg.png);
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		position: relative;
		height: 602px;
	}

	@media (max-width: 1024px) {
		.advantages-section {
			height: auto;
			padding-bottom: 40px;
		}
	}

	@media (max-width: 768px) {
		.advantages-section {
			padding-bottom: 32px;
		}
	}

	@media (max-width: 480px) {
		.advantages-section {
			padding-bottom: 24px;
		}
	}

	.advantages-subtitle {
		font-size: 18px;
		font-family: PingFang SC;
		color: #666;
		text-align: center;
		margin-bottom: 40px;
	}

	.advantages-grid {
		margin-top: 100px;
		display: grid;
		grid-template-columns: repeat(6, 1fr);
		grid-template-rows: auto;
		width: 100%;
		grid-gap: 10px;
	}

	@media (max-width: 768px) {
		.advantages-subtitle {
			font-size: 16px;
			margin-bottom: 32px;
			padding: 0 16px;
		}
	}

	@media (max-width: 480px) {
		.advantages-subtitle {
			font-size: 14px;
			margin-bottom: 24px;
			padding: 0 12px;
		}
	}

	@media (max-width: 1024px) {
		.advantages-grid {
			margin-top: 60px;
		}
	}

	@media (max-width: 768px) {
		.advantages-grid {
			margin-top: 40px;
		}
	}

	@media (max-width: 480px) {
		.advantages-grid {
			margin-top: 32px;
		}
	}

	.advantage-card {
		height: 244px;
		border: 1px solid #ffffff;
		background: linear-gradient(153deg, #eaeef5 0%, #ffffff 100%);
		box-shadow: 0px 3px 20px rgba(5, 36, 82, 0.07);
		border-radius: 2px;
		cursor: pointer;
		transition: width 0.7s cubic-bezier(0.22, 1, 0.36, 1);
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		overflow: hidden;
	}

	/* 推拉门：蓝色层从左往右滑入（与设计图一致 #2170ED） */
	.advantage-card::before {
		content: '';
		position: absolute;
		inset: 0;
		background: #2170ED;
		background-image: url(/static/baozhang_bg.png);
		background-size: 124px 124px;
		background-position: right top;
		background-repeat: no-repeat;
		transform: translateX(-100%);
		transition: transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);
		z-index: 0;
		will-change: transform;
	}

	.advantage-card-active::before {
		transform: translateX(0);
	}

	.advantage-card .service_content {
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		position: relative;
		z-index: 1;
	}

	/* 激活态：与设计图一致，左对齐、留白、图标白底白边 */
	.advantage-card-active .service_content {
		align-items: flex-start;
		text-align: left;
		padding: 28px 24px;
		width: 100%;
		box-sizing: border-box;
	}

	.advantage-card-active .service_content img {
		width: 30px;
		height: 30px;
		/* padding: 10px; */
		box-sizing: border-box;
	}

	.advantage-card .sm_line {
		display: none;
		margin: 0;
	}

	.advantage-card-active .sm_line {
		display: block;
		width: 40px;
		height: 2px;
		background: rgba(255, 255, 255, 0.9);
		border-radius: 1px;
		margin: 12px 0 10px 0;
	}

	.advantage-card:last-child {
		border-right: none;
	}

	.advantage-card-active {
		width: 400px;
		color: #fff;
	}

	@media (max-width: 1200px) {
		.advantage-card-active {
			width: auto;
			min-width: 300px;
		}
	}

	@media (max-width: 768px) {
		.advantage-card {
			height: auto;
			min-height: 180px;
		}

		.advantage-card-active {
			width: 100%;
			min-width: auto;
		}

		.advantage-card-active .service_desc {
			width: 100%;
			height: auto;
		}
	}

	@media (max-width: 480px) {
		.advantage-card {
			min-height: 160px;
		}

		.service_content img {
			width: 50px;
			height: 50px;
		}

		.advantage-card-active .service_content {
			padding: 20px 16px;
		}

		.advantage-card-active .service_content img {
			width: 28px;
			height: 28px;
		}

		.advantage-card-active .service_title {
			font-size: 20px;
			margin: 16px 0 8px;
		}

		.advantage-card-active .service_desc {
			font-size: 13px;
			line-height: 20px;
			margin-top: 16px;
		}
	}

	.advantage-card-active .advantage-title,
	.advantage-card-active .advantage-desc,
	.advantage-card-active .service_title,
	.advantage-card-active .service_desc {
		color: #ffffff;
	}

	.advantage-icon {
		width: 42px;
		height: 42px;
		border-radius: 10px;
		background: #eff6ff;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 18px;
		color: #2563eb;
	}

	.advantage-icon-inner {
		font-size: 22px;
		line-height: 1;
	}

	.advantage-card-active .advantage-icon {
		background: rgba(255, 255, 255, 0.18);
		color: #ffffff;
	}

	.advantage-title {
		font-size: 20px;
		font-weight: 600;
		color: #1e293b;
		margin: 0 0 10px;
	}

	.advantage-card-active .advantage-title,
	.advantage-card-active .service_title {
		position: relative;
		padding-bottom: 0;
		font-size: 24px;
		font-family: PingFang SC;
		font-weight: 600;
		line-height: 18px;
		color: #ffffff;
		margin: 20px 0 10px;
	}

	/* 分隔线由 .sm_line 展示，此处不再用 ::after */
	.advantage-card-active .advantage-title::after,
	.advantage-card-active .service_title::after {
		display: none;
	}

	.advantage-desc {
		font-size: 13px;
		color: #64748b;
		line-height: 1.7;
		margin: 8px 0 0;
		display: none;
	}

	.advantage-card .service_desc {
		display: none;
		opacity: 0;
		transition: opacity 0.55s cubic-bezier(0.22, 1, 0.36, 1);
	}

	.advantage-card-active .advantage-desc,
	.advantage-card-active .service_desc {
		display: block;
		opacity: 1;
		width: 308px;
		height: 46px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		line-height: 22px;
		color: #ffffff;
		margin-top: 20px;
	}

	@media (max-width: 1200px) {
		.advantages-grid {
			grid-template-columns: repeat(3, minmax(0, 1fr));
		}
	}

	@media (max-width: 768px) {
		.advantages-grid {
			grid-template-columns: repeat(2, minmax(0, 1fr));
			grid-gap: 8px;
			box-shadow: 0 10px 24px rgba(15, 23, 42, 0.04);
		}

		.advantage-card-active {
			transform: none;
		}

		.service_title {
			font-size: 16px;
		}
	}

	@media (max-width: 576px) {
		.advantages-grid {
			grid-template-columns: 1fr;
			grid-gap: 8px;
		}

		.service_title {
			font-size: 15px;
		}
	}

	/* 我们的合作客户 */
	.clients-section {
		background: #fff;
		padding: 80px 0;
	}

	.clients-slogan {
		color: #999;
		margin-bottom: 48px;
	}

	.clients-grid {
		display: grid;
		grid-template-columns: repeat(6, 1fr);
		gap: 24px;
	}

	.client-card {
		background: #fff;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
		border-radius: 8px;
		padding: 24px;
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: 100px;
		transition: box-shadow 0.3s;
	}

	.client-card:hover {
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
	}

	.client-logo {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
	}

	.client-logo img {
		max-width: 100%;
		max-height: 56px;
		object-fit: contain;
	}

	.client-name {
		font-size: 13px;
		color: #333;
		text-align: center;
		line-height: 1.4;
	}

	@media (max-width: 1200px) {
		.clients-grid {
			grid-template-columns: repeat(4, 1fr);
		}
	}

	@media (max-width: 768px) {
		.clients-section {
			padding: 48px 0;
		}

		.clients-grid {
			grid-template-columns: repeat(3, 1fr);
			gap: 16px;
		}

		.client-card {
			min-height: 80px;
			padding: 16px;
		}

		.client-name {
			font-size: 12px;
		}
	}

	@media (max-width: 576px) {
		.clients-grid {
			grid-template-columns: repeat(2, 1fr);
			gap: 12px;
		}

		.client-card {
			min-height: 70px;
			padding: 12px;
		}

		.client-logo img {
			max-height: 40px;
		}

		.client-name {
			font-size: 11px;
		}
	}

	@media (max-width: 480px) {
		.clients-section {
			padding: 40px 0;
		}

		.clients-grid {
			gap: 10px;
		}

		.client-card {
			min-height: 60px;
			padding: 10px;
		}
	}

	@media (max-width: 360px) {
		.clients-grid {
			grid-template-columns: repeat(2, 1fr);
			gap: 8px;
		}

		.client-card {
			min-height: 55px;
			padding: 8px;
		}

		.client-logo img {
			max-height: 35px;
		}
	}

	/* Footer */
	.footer {
		background: #1e293b;
		color: #94a3b8;
		padding: 48px 0 24px;
	}

	.footer-links {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		gap: 24px;
		margin-bottom: 24px;
	}

	.footer-links a {
		color: #94a3b8;
		text-decoration: none;
		font-size: 14px;
	}

	.footer-links a:hover {
		color: #fff;
	}

	.footer-contact {
		text-align: center;
		margin-bottom: 16px;
	}

	.tel {
		font-size: 15px;
		color: #cbd5e1;
	}

	.icp {
		text-align: center;
		font-size: 13px;
		opacity: 0.8;
		margin-top: 12px;
	}

	.footer-copy {
		text-align: center;
		font-size: 13px;
		opacity: 0.8;
	}

	@media (max-width: 768px) {
		.footer {
			padding: 40px 0 20px;
		}

		.footer-links {
			gap: 16px;
			margin-bottom: 20px;
		}

		.footer-links a {
			font-size: 13px;
		}

		.tel {
			font-size: 14px;
		}

		.footer-copy {
			font-size: 12px;
		}
	}

	@media (max-width: 480px) {
		.footer {
			padding: 32px 0 16px;
		}

		.footer-links {
			flex-direction: column;
			gap: 12px;
			margin-bottom: 16px;
			padding: 0 16px;
		}

		.footer-links a {
			font-size: 12px;
		}

		.tel {
			font-size: 13px;
			padding: 0 16px;
		}

		.footer-copy {
			font-size: 11px;
			padding: 0 16px;
		}
	}

	@media (max-width: 360px) {
		.footer-links a {
			font-size: 11px;
		}

		.tel {
			font-size: 12px;
		}

		.footer-copy {
			font-size: 10px;
		}
	}
</style>